import { useEffect, useState } from "react";
import "./Popup.css";

export default function ExcluirEquipamento({ open, onClose, onConfirmar, titulo }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  async function handleExcluir() {
    setBusy(true);
    setErr("");
    try {
      await onConfirmar?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao excluir");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="eqpm-modal-overlay" onClick={onClose}>
      <div className="eqpm-modal-card eqpm-modal-card--sm" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="eqpm-modal-head">
          <h2>Excluir equipamento</h2>
          <button className="eqpm-modal-close" type="button" onClick={onClose} aria-label="Fechar">
            ×
          </button>
        </div>

        <div className="eqpm-modal-body">
          <p className="eqpm-modal-text">
            Tem certeza que deseja excluir <b>{titulo || "este equipamento"}</b>?
          </p>
          <p className="eqpm-modal-text">Essa ação não pode ser desfeita.</p>
          {err ? <div className="eqpm-modal-err">{err}</div> : null}
        </div>

        <div className="eqpm-modal-foot">
          <button className="eqpm-btn" type="button" onClick={onClose} disabled={busy}>
            Cancelar
          </button>
          <button className="eqpm-btn eqpm-btn-danger" type="button" onClick={handleExcluir} disabled={busy}>
            {busy ? "Excluindo..." : "Excluir"}
          </button>
        </div>
      </div>
    </div>
  );
}
